<template>
    <div>
        <v-mu-picker ref="muPicker" :code="$safe(muhasebe,'MuhasebeKodu')" v-on:pick="onPickMuhasebe"/>
        <div class="row">
            <div class="col-lg-6 mb-1">
                <label class="form-label">KDV</label>
                <div>
                    <b-form-radio v-on:input="calculateAmounts" v-model="value.Kdv_Dahil" inline :value="true">Dahil</b-form-radio>
                    <b-form-radio v-on:input="calculateAmounts" v-model="value.Kdv_Dahil" inline :value="false">Hariç</b-form-radio>
                </div>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Gider Hesap Kodu ve Adı</label>
                <div class="d-flex g-50">
                    <input class="form-control" :value="$safe(muhasebe,'MuhasebeKodu')" readonly disabled placeholder="Muhasebe Kodu"/>
                    <button class="btn btn-outline-primary text-nowrap" v-on:click="$refs.muPicker.pick()">Hesap Seç</button>
                </div>
                <small>{{ $safe(muhasebe,'MuhasebeAdi') }}</small>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Miktar</label>
                <input class="form-control" type="number" placeholder="Miktar" v-model="value.Miktar"/>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Tutar (TL)</label>
                <v-currency-input input-class="text-right" :disabled="doviz" :value="value.Tutar" v-on:update-value="currencyAmount => {value.Tutar = currencyAmount; calculateAmounts()}"></v-currency-input>
            </div>
            <div class="col-lg-6 mb-1" v-if="doviz">
                <label class="form-label">Döviz Tutar</label>
                <v-currency-input input-class="text-right" :value="value.DOVTUT" v-on:update-value="currencyAmount => {value.DOVTUT = currencyAmount; calculateAmounts()}"></v-currency-input>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">KDV Hesap Kodu</label>
                <v-select-list v-model="KDVHesCode" :options="KDVHesCodeList" label="Information" placeholder="KDV Hesap Kodu"></v-select-list>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">KDV Oranı (%)</label>
                <input class="form-control" v-on:input="calculateAmounts" v-model="value.Kdv_Oran" type="number" />
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">KDV Tutar (TL)</label>
                <v-currency-input disabled input-class="text-right" :value="value.KdvTutar" v-on:update-value="currencyAmount => value.KdvTutar = currencyAmount"></v-currency-input>
            </div>
            <div class="col-lg-6 mb-1" v-if="doviz">
                <label class="form-label">KDV Döviz Tutar</label>
                <v-currency-input disabled input-class="text-right" :value="value.KdvDovTut" v-on:update-value="currencyAmount => value.KdvDovTut = currencyAmount"></v-currency-input>
            </div>
    
            <div class="col-lg-6 mb-1">
                <label class="form-label">KDV'siz Tutar (TL)</label>
                <v-currency-input disabled input-class="text-right" :value="kdvsiztutar" v-on:update-value="currencyAmount => kdvsiztutar = currencyAmount"></v-currency-input>
            </div>
            <div class="col-lg-6 mb-1" v-if="doviz">
                <label class="form-label">KDV'siz Döviz Tutar</label>
                <v-currency-input disabled input-class="text-right" :value="kdvsizdovtutar" v-on:update-value="currencyAmount => kdvsizdovtutar = currencyAmount"></v-currency-input>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">KDV'li Tutar (TL)</label>
                <v-currency-input disabled input-class="text-right" :value="kdvlitutar" v-on:update-value="currencyAmount => kdvlitutar = currencyAmount"></v-currency-input>
            </div>
            <div class="col-lg-6 mb-1" v-if="doviz">
                <label class="form-label">KDV'li Döviz Tutar</label>
                <v-currency-input disabled input-class="text-right" :value="kdvlidovtutar" v-on:update-value="currencyAmount => kdvlidovtutar = currencyAmount"></v-currency-input>
            </div>
    
            
            <div class="col-lg-6 mb-1">
                <label class="form-label">Açıklama</label>
                <textarea class="form-control resize-none" rows="2" v-model="value.Aciklama" placeholder="Açıklama"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormRadio } from 'bootstrap-vue'
import NetsisOperationsApi from '@/api/netsis-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VMuPicker from '@/components/VMuPicker.vue';

export default {
    components:{
        BFormRadio,
        VCurrencyInput,
        VMuPicker
    },
    props:{
        value:Object,
        doviz:{
            type:Boolean,
            default: false
        },
        currencyRate:{
            type:Number,
            default:1
        }
    },
    mounted(){
    },
    data(){
        return {
            KDVHesCodeLoading:false,
            KDVHesCodeList:[
                {Information:"191-01-01-0001 - % 1 KDV",MuhasebeAdi:"% 1 KDV",MuhasebeKodu:"191-01-01-0001",Value:1},
                {Information:"191-01-01-0010 - % 10 KDV",MuhasebeAdi:"% 10 KDV",MuhasebeKodu:"191-01-01-0010",Value:10},
                {Information:"191-01-01-0020 - % 20 KDV",MuhasebeAdi:"% 20 KDV",MuhasebeKodu:"191-01-01-0020",Value:20},
            ],
            kdvsiztutar:null,
            kdvsizdovtutar:null,
            kdvlitutar:null,
            kdvlidovtutar:null,
            muhasebe:null
        }
    },
    methods:{
        getKDVHesCodeList(){
            this.KDVHesCodeLoading = true
            NetsisOperationsApi.GetKDVCodes().then(res => {
                this.KDVHesCodeList = res.data.Data || []
                this.KDVHesCodeLoading = false
            }).catch(() => {
                this.KDVHesCodeLoading = false
            })
        },
        calculateAmounts(){
            const tutar = this.value.Tutar || 0
            const dovtutar = this.value.DOVTUT || 0
            const kdvrate = this.value.Kdv_Oran || 0

            if(this.value.Kdv_Dahil){
                if(!this.doviz){
                    this.kdvsiztutar = tutar / (1 + (kdvrate / 100))
                    this.value.KdvTutar =  tutar - this.kdvsiztutar
                    this.kdvlitutar = tutar
                }else{
                    this.kdvsizdovtutar = dovtutar / ( 1 + (kdvrate / 100))
                    this.value.KdvDovTut = dovtutar - this.kdvsizdovtutar
                    this.kdvlidovtutar = dovtutar
                    this.value.KdvTutar = this.value.KdvDovTut * this.currencyRate
                    this.kdvsiztutar = this.kdvsizdovtutar * this.currencyRate
                    this.kdvlitutar = dovtutar * this.currencyRate 
                    this.value.Tutar = this.kdvlitutar
                }
            }else{
                if(!this.doviz){
                    this.value.KdvTutar = tutar * (kdvrate / 100)
                    this.kdvsiztutar = tutar
                    this.kdvlitutar = tutar + this.value.KdvTutar
                }else{
                    this.value.KdvDovTut = dovtutar * (kdvrate / 100)
                    this.value.KdvTutar = (this.value.KdvDovTut) * this.currencyRate
                    this.kdvsizdovtutar = dovtutar
                    this.kdvsiztutar = dovtutar * this.currencyRate
                    this.value.Tutar = dovtutar * this.currencyRate
                    this.kdvlidovtutar = this.kdvsizdovtutar + this.value.KdvDovTut
                    this.kdvlitutar = this.kdvlidovtutar * this.currencyRate
                }
            }   
        },
        onPickMuhasebe(e){
            this.value.Kod = e?.MuhasebeKodu || null
            this.value.Ad = e?.MuhasebeAdi || null
            this.muhasebe = e
        },
    },
    computed:{
        KDVHesCode:{
            get:function(){
                return this.KDVHesCodeList.find(s=>s.MuhasebeKodu==this.value.KdvMuhKod)
            },
            set:function(value){
                this.value.KdvMuhKod = value?.MuhasebeKodu || null
                this.value.KdvMuhAdi = value?.MuhasebeAdi || null
                if(value?.Value){
                    this.value.Kdv_Oran = value.Value
                    this.calculateAmounts()
                }
            }
        },
    }
}
</script>